import { BUSINESS } from "@/lib/constants";
import { Phone } from "lucide-react";

export default function StickyCallBar() {
  return (
    <a
      href={BUSINESS.phoneHref}
      data-testid="sticky-call-bar"
      className="md:hidden fixed bottom-4 left-4 right-4 z-50 inline-flex items-center justify-center gap-2 bg-[#8AB273] text-black font-semibold py-4 rounded-full shadow-2xl shadow-[#8AB273]/25"
    >
      <Phone size={18} />
      Call {BUSINESS.phone}
    </a>
  );
}
